/*
 * Created by yvesb on 30/05/2017.
 */
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
import CMacroDecrementationVariable from '../objets/CMacroDecrementationVariable'
import { getStr } from '../kernel/kernel'
import MacIncDecVarDlg from '../dialogs/MacIncDecVarDlg'

export default CMacroDecrementationVariable

CMacroDecrementationVariable.prototype.infoHist = function () {
  return this.getName() + ' : ' + getStr('chinfo122') + ' ' + getStr('chinfo122Bis') +
    ' ' + this.variableAssociee.nomCalcul
}

CMacroDecrementationVariable.prototype.modifDlg = function (app, callBack1, callBack2) {
  new MacIncDecVarDlg(app, false, this, true, callBack1, callBack2)
}
